import { native } from '@forest/native-services'
import { logNonFatalError } from '~/lib/log-errors'

/**
 * Resolves a content title key against the native string catalog. An echoed
 * key is a miss (GLOSSARY.md "Echo-key miss") and shows as empty, as does a
 * failed bridge call — a missing name never blocks the reward it names.
 */
export async function localizeContentTitle(
  key: string | null,
): Promise<string> {
  if (!key) return ''
  try {
    const title = await native.l10n.getLocalizedString({ key })
    return title === key ? '' : title
  } catch (error) {
    logNonFatalError({
      name: 'failed_to_localize_content_title',
      code: 1,
      params: { key, message: String(error) },
    })
    return ''
  }
}
